import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Box from '../../Box/index.esm.js';
import Button from '../../Button/index.esm.js';
import '../../../hooks/use-safe-layout-effects.esm.js';
import '../../../hooks/use-callback-ref.esm.js';
import '../../../hooks/use-clickable.esm.js';
import '../../../hooks/use-clipboard.esm.js';
import { useComboboxDropdownStyle } from '../../../hooks/use-combobox-dropdown-style.esm.js';
import '../../../hooks/use-combobox-style.esm.js';
import '../../../hooks/use-controllable.esm.js';
import '../../../hooks/use-local-storage.esm.js';
import '../../../hooks/use-media.esm.js';
import '../../../hooks/use-prefers-dark-mode.esm.js';
import '../../../hooks/use-dark-mode.esm.js';
import '../../../hooks/use-force-update.esm.js';
import '../../../hooks/use-descendant.esm.js';
import '../../../hooks/use-id.esm.js';
import '../../../hooks/use-previous.esm.js';
import '../../../hooks/use-disclosure.esm.js';
import '../../../hooks/use-dropdown-style.esm.js';
import '../../../hooks/use-latest-ref.esm.js';
import '../../../hooks/use-event-listener.esm.js';
import '../../../hooks/use-event-listener-v2.esm.js';
import '../../../hooks/use-update-effect.esm.js';
import '../../../hooks/use-focus-on-hide.esm.js';
import '../../../hooks/use-pointer-event.esm.js';
import '../../../hooks/use-focus-on-pointerdown.esm.js';
import '../../../hooks/use-focus-on-show.esm.js';
import '../../../hooks/use-fork-ref.esm.js';
import '../../../hooks/use-hints.esm.js';
import '../../../hooks/use-input-style.esm.js';
import '../../../hooks/use-key-press.esm.js';
import '../../../hooks/use-lock-body-scroll.esm.js';
import '../../../hooks/use-platform.esm.js';
import '../../../hooks/use-shortcut.esm.js';
import Text from '../../Text/index.esm.js';
import { useComboboxContext } from '../context.esm.js';
import { compareItems } from '../utils.esm.js';

var OptionItem = function OptionItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      rest = _objectWithoutPropertiesLoose(_ref, ["item", "index"]);

  var _useComboboxContext = useComboboxContext(),
      getItemProps = _useComboboxContext.getItemProps,
      size = _useComboboxContext.size,
      highlightedIndex = _useComboboxContext.highlightedIndex,
      selectedItems = _useComboboxContext.selectedItems,
      hideItemOnSelect = _useComboboxContext.hideItemOnSelect;

  var hasCheckIcon = !hideItemOnSelect;
  var checked = hasCheckIcon && (item.checked || selectedItems.some(function (selectedItem) {
    return compareItems(item, selectedItem);
  }));
  var highlighted = highlightedIndex === index;

  var _useComboboxDropdownS = useComboboxDropdownStyle({
    highlighted: highlighted,
    size: size,
    hasCheckIcon: hasCheckIcon,
    checked: checked
  }),
      buttonStyle = _useComboboxDropdownS.buttonStyle,
      textStyle = _useComboboxDropdownS.textStyle;

  return React__default.createElement(Button, _extends({
    as: "li",
    "data-index": index,
    iconBefore: checked ? 'check' : undefined,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }, getItemProps({
    item: item,
    index: index
  }), buttonStyle, rest), React__default.createElement(Text, _extends({}, textStyle), item.value), React__default.createElement(Box, {
    flex: "flex-1"
  }, item.rightExtra));
};

export default OptionItem;
//# sourceMappingURL=OptionItem.esm.js.map
